import axiosTemplate from '../../utils/axiosTemplate';
const instance = () => axiosTemplate(process.env.VUE_APP_PROMOTIONS_ENDPOINT);
export default instance;
